<script>
    import Grapher from "./Grapher.svelte";

    export let values;
    export let headers;
    export let title;
    export let infoHover;
    export let bigNum;
    
</script>

<style> 
    h1 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 22px;
    }

    h2 {
        font-family: Oswald;
        font-style: normal;
        font-weight: 500;
        font-size: 29px;
        line-height: 29px;

        color: #3BA1FF;
    }

    .wrapper {
        margin: 5% 10%;
    }
</style>

<main style="flex-grow:1"> 
    <div class="container">
        <div class="wrapper">
            <h1> { title } </h1>
            <h2> { bigNum }</h2>
            <Grapher headers={headers} values={values}/>
        </div>
    </div>
</main>